import { Panel } from "./Panel";
import { LoadContext } from "../../../utils";
import { Game } from '../../../game';
import { Focusable, InteractiveWrapper, Switch } from '../../../ui';
import {
    Sprite,
} from "pixi.js";

export class ClosedCaptions extends Panel
{
    private switch:Switch;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor( game:Game )
    {
        super(
            game,
            "Closed Captions",
            {
                title: "CYB_Panel2_ClosedCaptions",
                explain: 'CYB_Panel2_Captions_Explanation',
                settings: 'CYB_Panel2_Captions_Settings',
            },
            {width: 656, height: 209}
        );
        const icon:Sprite = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_closedcaptions']);
        icon.position.set( this.icon_x, this.icon_y );
        this.addChild( icon );

        this.switch = new Switch();
        this.switch.position.set( 270, 135 );
        this.updateToMatchSetting();

        this.switch.on( "switchChanged", (newValue:boolean)=>{
            this.game.vo.stop();
            this.game.app.state.captionsMuted.value = !newValue;
            this.playSwitchVO(this.switch);
            const eventName: string = newValue ? "closed_captions_on" : "closed_captions_off";
            this.game.logEvent("change_setting", eventName);
        });
        this.disposables.add(new InteractiveWrapper(this.switch, {
            onHover: () => {
                this.playSwitchHover( this.switch );
            },
            onFocus: () => {
                this.playSwitchHover( this.switch, true );
            },
            onTap: () => {}
        }));
        this.addChild( this.switch );
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [this.switch] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.switch.isOn = !this.game.app.state.captionsMuted.value;
    }

    destroy()
    {
        super.destroy();
    }
}